import { Injectable } from '@angular/core';
import { WindowRefrenceServiceService } from './window-refrence-service.service';

declare var gtag: any;

@Injectable({
  providedIn: 'root'
})
export class DataLayerServiceService {
  private window: any;

  constructor(
    private _windowRef: WindowRefrenceServiceService,
  
  ) {
    this.window = this._windowRef.nativeWindow;
  }

  private pingHome(obj: any) {
    if (!this.window || !this.window.dataLayer) return;

    this.window.dataLayer.push({ ecommerce: null });

    if (obj) {
      if (typeof gtag !== 'undefined') {
        gtag(obj);
      } else {
        this.window.dataLayer.push(obj);
      }
    }
  }

  logPageView(data: any) {
    const hit = {
      event: 'view_item',
      ecommerce: {
        items: [
          {
            item_id: data.CatalogItemId,
            item_name: data.productDetails?.ProductName || '',
            affiliation: 'Local',
            coupon: ' ',
            currency: 'CAD',
            discount: 0,
            index: 0,
            item_brand: data.productDetails?.Brand || '',
            item_category: 'item_category',
            item_category2: 'item_category2',
            item_category3: 'item_category3',
            item_category4: 'item_category4',
            item_category5: 'item_category5',
            item_list_id: data.CatalogItemId,
            item_list_name: data.productDetails?.ProductName || '',
            item_variant: 'Local',
            location_id: 'location',
            price: data.myPrice,
            quantity: 0
          }
        ]
      }
    };
    this.pingHome(hit);
  }

  logEvent(event: string, category: string, action: string, label: string) {
    const hit = {
      event,
      category,
      action,
      label
    };
    this.pingHome(hit);
  }

  OrderPlace(data: any) {
    const items = data.productDetails.map((e: any) => ({
      item_id: e.inventoryId,
      item_name: e.productName,
      affiliation: 'Local',
      coupon: 'Local',
      currency: 'CAD',
      discount: data.discount,
      index: 0,
      item_brand: 'Local',
      item_category: 'item_category',
      item_category2: 'item_category2',
      item_category3: 'item_category3',
      item_category4: 'item_category4',
      item_category5: 'item_category5',
      item_list_id: 'item_list_id',
      item_list_name: e.productName,
      item_variant: 'Local',
      location_id: 'location',
      price: e.price * e.selectQuantity,
      quantity: e.selectQuantity
    }));

    const hit = {
      event: 'purchase',
      ecommerce: {
        transaction_id: data.orderDisplayId,
        affiliation: 'Local',
        value: data.subTotal,
        tax: data.tax,
        shipping: 'Local',
        currency: 'CAD',
        coupon: 'Local',
        items
      }
    };

    this.pingHome(hit);
  }

  addToCartGTM(data: any[]) {
    data.forEach(e => {
      const hit = {
        event: 'add_to_cart',
        ecommerce: {
          currency: 'CAD',
          value: e.price * e.selectQuantity,
          items: [
            {
              item_id: e.inventoryId,
              item_name: e.productName,
              affiliation: 'Local',
              coupon: '',
              currency: 'CAD',
              discount: 0,
              index: 0,
              item_brand: 0,
              item_category: 'item_category',
              item_category2: 'item_category2',
              item_category3: 'item_category3',
              item_category4: 'item_category4',
              item_category5: 'item_category5',
              item_list_id: e.inventoryId,
              item_list_name: e.productName,
              item_variant: 'Local',
              location_id: 'location',
              price: e.price * e.selectQuantity,
              quantity: e.selectQuantity
            }
          ]
        }
      };
      this.pingHome(hit);
    });
  }

  addToCartGTMGuest(data: any[]) {
    data.forEach(e => {
      const hit = {
        event: 'add_to_cart',
        ecommerce: {
          currency: 'CAD',
          value: e.price * e.quantity,
          items: [
            {
              item_id: e.productId,
              item_name: e.productName,
              affiliation: 'Local',
              coupon: '',
              currency: 'CAD',
              discount: 0,
              index: 0,
              item_brand: 0,
              item_category: 'item_category',
              item_category2: 'item_category2',
              item_category3: 'item_category3',
              item_category4: 'item_category4',
              item_category5: 'item_category5',
              item_list_id: e.productId,
              item_list_name: e.productName,
              item_variant: 'Local',
              location_id: 'location',
              price: e.price * e.quantity,
              quantity: e.quantity
            }
          ]
        }
      };
      this.pingHome(hit);
    });
  }

  itemcheckoutGTM(data: any[]) {
    data.forEach(e => {
      const hit = {
        event: 'begin_checkout',
        ecommerce: {
          currency: 'CAD',
          value: e.price * e.selectQuantity,
          coupon: '',
          items: [
            {
              item_id: e.inventoryId,
              item_name: e.productName,
              affiliation: 'Local',
              coupon: '',
              currency: 'CAD',
              discount: 0,
              index: 0,
              item_brand: '',
              item_category: '',
              item_category2: '',
              item_category3: '',
              item_category4: '',
              item_category5: '',
              item_list_id: '',
              item_list_name: e.productName,
              item_variant: '',
              location_id: '',
              price: e.price * e.selectQuantity,
              quantity: e.selectQuantity
            }
          ]
        }
      };
      this.pingHome(hit);
    });
  }

  guestitemcheckoutGTM(data: any[]) {
    data.forEach(e => {
      const hit = {
        event: 'begin_checkout',
        ecommerce: {
          currency: 'CAD',
          value: e.price * e.quantity,
          coupon: '',
          items: [
            {
              item_id: e.productId,
              item_name: e.productName,
              affiliation: 'Local',
              coupon: '',
              currency: 'CAD',
              discount: 0,
              index: 0,
              item_brand: '',
              item_category: '',
              item_category2: '',
              item_category3: '',
              item_category4: '',
              item_category5: '',
              item_list_id: '',
              item_list_name: e.productName,
              item_variant: '',
              location_id: '',
              price: e.price * e.quantity,
              quantity: e.quantity
            }
          ]
        }
      };
      this.pingHome(hit);
    });
  }

  logCustomDimensionTest(value: any) {
    const hit = {
      event: 'custom-dimension',
      value
    };
    this.pingHome(hit);
  }
}
